import { render, staticRenderFns } from "./AccountBox.vue?vue&type=template&id=1883e79e&scoped=true"
import script from "./AccountBox.vue?vue&type=script&lang=js"
export * from "./AccountBox.vue?vue&type=script&lang=js"
import style0 from "./AccountBox.vue?vue&type=style&index=0&id=1883e79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883e79e",
  null
  
)

export default component.exports